import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { MetaAppSettings, type MetaAppUpdateRequest } from '@rp/contracts'
import { useReadySession } from '../../session/useSession'
import { settingsKeys } from './queries'

export const useMetaApp = () => {
  const { api, membership } = useReadySession()
  return useQuery({
    queryKey: settingsKeys.metaApp(membership.tenantId),
    queryFn: async () =>
      (await api.request(MetaAppSettings.nullable(), { method: 'GET', path: '/v1/meta-app' })).data,
  })
}

export const useSaveMetaApp = () => {
  const { api, membership } = useReadySession()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body: MetaAppUpdateRequest) =>
      (await api.request(MetaAppSettings, { method: 'PUT', path: '/v1/meta-app', body })).data,
    onSuccess: (saved) => {
      queryClient.setQueryData(settingsKeys.metaApp(membership.tenantId), saved)
      void queryClient.invalidateQueries({ queryKey: settingsKeys.channels(membership.tenantId) })
    },
  })
}
